export default __webpack_public_path__ + "static/media/brand.2c2808ee.png";